import React from 'react';

export const MainGames = () => {
  const games = [
    {
      key: 'lol',
      name: '리그오브레전드',
      image: '/image/layout/game-lol.svg',
      web: 'https://www.leagueoflegends.com/ko-kr/',
      download: 'https://download.kr.riotgames.com/league',
    },
    {
      key: 'valorant',
      name: '발로란트',
      image: '/image/layout/game-valorant.png',
      web: 'https://playvalorant.com/ko-kr/',
      download: 'https://playvalorant.com/ko-kr/download/',
    },
    {
      key: 'lor',
      name: '레전드오브룬테라',
      image: '/image/layout/game-lor.svg',
      web: 'https://playruneterra.com/ko-kr/',
      download: 'https://download.kr.riotgames.com/lor',
    },
  ];

  return (
    <ul className="main-games">
      {games.map(game => (
        <li key={game.key} className={`game-banner game-banner--${game.key}`}>
          <img src={game.image} alt={game.name} />
          <div className="game-banner__links">
            <a href={game.web} target="_blank" rel="noopener noreferrer">
              공식 웹사이트
            </a>
            <a href={game.download} target="_blank" rel="noopener noreferrer">
              게임 다운로드
            </a>
          </div>
        </li>
      ))}
    </ul>
  );
};
